import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class AtendimentoTipoEspecificoService extends BaseService {
  constructor() {
    super(ConfigApi.atendimentoTipoEnfURL);
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.nome = '';
    this.limit = 0;
    this.page = 0;
  }
}
export default new AtendimentoTipoEspecificoService();
